// @flow
import * as React from 'react'
import { SubscriptionPlanOption } from './SubscriptionPlanOption'
import type { SubscriptionLengthType } from '../../../flowTypes'
import { Form } from '@components/shared'

export type PropsType = {
  textAnnualArialLabel: string,
  textMonthlyArialLabel: string,
  plan?: SubscriptionLengthType,
  promoText?: string,
  promoPlan?: 'annual' | 'monthly' | 'six_months',
  crossOutText: boolean,
  planChosen: boolean,
  badgeText?: string,
  price?: string,
  annualBilledText?: string,
  subscriptionPromoText?: string,
  featureAnnualOnly: boolean,
  annualPriceText?: string
}

export type StateType = {
  selection: 'monthly' | 'annual'
}

export type DispatchPropsType = {
  choosePlan: (plan: 'monthly' | 'annual') => void
}

class ChoosePlan extends React.PureComponent<
  PropsType & DispatchPropsType,
  StateType
> {
  constructor (props: PropsType & DispatchPropsType): void {
    super(props)
    this.state = {
      selection: this.props.featureAnnualOnly
        ? 'annual'
        : this.props.plan === 'monthly'
          ? 'monthly'
          : 'annual'
    }
  }

  componentDidMount (): void {
    if (!this.props.planChosen || (this.props.featureAnnualOnly && this.props.promoPlan !== 'annual')) {
      this.props.choosePlan('annual')
    }
  }

  chooseAnnual = (e: any): void => {
    e.preventDefault()
    this.props.choosePlan('annual')
    this.setState({
      selection: 'annual'
    })
  }

  chooseMonthly = (e: any): void => {
    e.preventDefault()
    this.props.choosePlan('monthly')
    this.setState({
      selection: 'monthly'
    })
  }

  submitPlan = (): void => {
    if (this.state.selection === 'annual') {
      this.props.choosePlan('annual')
    } else {
      this.props.choosePlan('monthly')
    }
  }

  render (): React.Node {
    const {
      textAnnualArialLabel,
      textMonthlyArialLabel,
      promoText,
      promoPlan,
      crossOutText,
      badgeText,
      price,
      annualBilledText,
      subscriptionPromoText,
      featureAnnualOnly,
      annualPriceText
    } = this.props
    const monthlyPriceText = `$12.99/month`

    return (
      <Form id='choosePlan' onSubmit={this.submitPlan}>
        <SubscriptionPlanOption
          name={'annual-button'}
          formId={'choosePlan'}
          onClick={this.chooseAnnual}
          planName={'annual'}
          selected={this.state.selection === 'annual'}
          text={annualPriceText || `$69.99/year\n(only $5.83/month)`}
          arialLabel={textAnnualArialLabel}
          badgeText={promoPlan === 'annual' ? badgeText : '7 Days Free'}
          billedText={annualBilledText || 'billed annually when trial ends'}
          promoText={promoPlan === 'annual' ? promoText : undefined}
          crossOutText={crossOutText}
          price={promoPlan === 'annual' ? price : undefined}
          subscriptionPromoText={promoPlan === 'annual' ? subscriptionPromoText : undefined}
          isAnnualOnly={featureAnnualOnly}
        />
        {!featureAnnualOnly && (
          <SubscriptionPlanOption
            planName={'monthly'}
            formId={'choosePlan'}
            name={'monthly-button'}
            onClick={this.chooseMonthly}
            selected={this.state.selection === 'monthly'}
            text={monthlyPriceText}
            arialLabel={textMonthlyArialLabel}
            billedText={'billed monthly'}
            badgeText={promoPlan === 'monthly' ? badgeText : undefined}
            promoText={promoPlan === 'monthly' ? promoText : undefined}
            crossOutText={crossOutText}
            price={promoPlan === 'monthly' ? price : undefined}
            subscriptionPromoText={promoPlan === 'monthly' ? subscriptionPromoText : undefined}
            isAnnualOnly={featureAnnualOnly}
          />
        )}
      </Form>
    )
  }
}

export default ChoosePlan
